




















































































import { email } from '@/utils/validators'
import Vue from 'vue'
import { productsEnum } from '@/utils/productsCode.constant'
import { GetProductDTO } from '@/utils/interfaces/topup.interface'
import { getProducts } from '@/api/Topup/topup.api'
import { createNautaTopup } from '@/api/Nauta/nauta.api'
import { VueForm } from '@/utils/interfaces'
import SuccessSnackbar from '../TopUps/SuccessSnackbar.vue'
import { Roles } from '@/plugins/permissions'
import PhoneTextField from '~/components/PhoneTextField.vue'
import TextButton from '~/components/TextButton.vue'

export default Vue.extend({
  components: {
    SuccessSnackbar,
    PhoneTextField,
    TextButton,
  },
  data() {
    return {
      Roles,
      rules: {
        nauta: (v: string) => {
          if (!this.$data.product.validation_regex) {
            return true
          }
          const regexp = new RegExp(this.$data.product.validation_regex)
          if (regexp.test(v + this.$data.append)) {
            return true
          }
          return this.$t('validation.invalid_nauta')
        },
        required: (v: string) => !!v || this.$t('validation.field-required'),
        email: (v: string) =>
          email(v + this.$data.append) || this.$t('validation.invalid_account'),
      },
      product: {} as GetProductDTO,
      append: '@nauta.com.cu',
      appends: ['@nauta.com.cu', '@nauta.co.cu'],
      crud: {
        client: '',
        destination_account: '',
        confirmation_account: '+1',
      },
      products: [] as GetProductDTO[],
      loading: false,
      showSuccess: false,
    }
  },
  methods: {
    async onSend() {
      const form = this.$refs.form as VueForm
      if ((this.crud.confirmation_account || '').length < 5) {
        this.crud.confirmation_account = ''
        await this.$nextTick()
      }
      if (!form.validate()) return
      try {
        this.loading = true
        await createNautaTopup({
          client: this.crud.client,
          destination_account: this.crud.destination_account + '@nauta.com.cu',
          amount: this.product.amount,
          product: this.product.code,
          confirmation_account: this.crud.confirmation_account,
        })
        this.showSuccess = true
        this.crud = {
          client: '',
          destination_account: '',
          confirmation_account: '+1',
        }
        form.resetValidation()
      } finally {
        this.loading = false
      }
    },
  },
  async mounted() {
    const response = await getProducts({ code: productsEnum.Nauta })
    this.products = response.data.results
    if (this.products.length) {
      this.product = this.products[0]
    }
  },
})
